<template>
  <app-layout @setCountry="onSetCountry">
    <bax-header-banner
      :user="this.$store.state.auth.user"
      headingMain="Manage Order"
      @goBack="goBack()"
    />

    <main>
      <div class="bax-section bax-select-patient-wrap">
        <div class="container">
          <download-order :order="orderDetail" />

          <vue-accordian
            title="Order Summary"
            :defaultOpen="false"
            :openAllButton="true"
            v-on:open-details="openAllDetails"
            v-on:close-details="closeAllDetails"
          >
            <div class="bax-order-summary">
              <ul>
                <li class="d-md-flex">
                  <span>Order Reference: </span>
                  <strong class="ml-auto text-right"
                    ><img
                      class="loading_animation"
                      src="@/assets/images/loading.gif"
                      alt="Loading"
                      v-if="!orderInfo.orderRef"
                    />{{ orderInfo.orderRef }}
                  </strong>
                </li>
                <li class="d-md-flex">
                  <span>Date Required: </span>
                  <strong class="ml-auto text-right"
                    ><img
                      class="loading_animation"
                      src="@/assets/images/loading.gif"
                      alt="Loading"
                      v-if="!orderInfo.date"
                    />{{ orderInfo.date }}</strong
                  >
                </li>
                <li class="d-md-flex" v-if="!isTPN()">
                  <span>Time Required: </span>
                  <strong class="ml-auto text-right"
                    ><img
                      class="loading_animation"
                      src="@/assets/images/loading.gif"
                      alt="Loading"
                      v-if="!orderInfo.time"
                    />{{ orderInfo.time }}</strong
                  >
                </li>
                <li class="d-md-flex" v-if="!isTPN()">
                  <span>Patients: </span>
                  <strong class="ml-auto text-right"
                    ><img
                      class="loading_animation"
                      src="@/assets/images/loading.gif"
                      alt="Loading"
                      v-if="ajaxCalls > 0"
                    />
                    <template v-if="orderInfo.patients_count > 0">{{
                      orderInfo.patients_count
                    }}</template>
                  </strong>
                </li>
                <li class="d-md-flex">
                  <span>Items Ordered: </span>
                  <strong class="ml-auto text-right"
                    ><img
                      class="loading_animation"
                      src="@/assets/images/loading.gif"
                      alt="Loading"
                      v-if="ajaxCalls > 0"
                    />
                    <template v-if="orderInfo.items_count > 0">{{
                      orderInfo.items_count
                    }}</template>
                  </strong>
                </li>
                <li class="d-md-flex">
                  <span>Comment: </span>
                  <strong class="ml-auto text-right">
                    {{ orderInfo.comment }}
                  </strong>
                </li>
              </ul>
            </div>

            <patient-list
              v-for="(patient, i) in patients"
              :key="i"
              :ref="'patient' + i"
              :patient="patient"
              v-on:edit-drug="onEditDrug"
              v-on:cancel-drug="showCancelDrugModal"
              v-on:order-changed="onOrderChanged"
              v-on:item-open="accordionOpened"
              v-on:item-close="accordionClosed"
            >
            </patient-list>
          </vue-accordian>
          <div class="bax-cta-block d-flex">
            <!-- <a href="javascript:;"
                            title="Print"
                            class="bax-btn bax-btn-bordered bax-btn-bordered-blue d-flex align-items-center justify-content-center ml-auto"><i class="icon-printer">
                            </i> Print
                        </a> -->
          </div>
        </div>
      </div>
    </main>

    <vue-modal :open="isEditModalOpen">
      <form novalidate @submit.prevent="updateOrderData" v-if="!hasError && !updateSuccess">
        <div
          class="bax-icon bax-success d-flex align-items-center justify-content-center edit-i-con"
        >
          <i class="icon-edit"></i>
        </div>
        <span class="edit-title">Edit item</span>
        <div>
          <div
            class="bax-form-group"
            v-bind:class="{ 'bax-form-error': $v.editDrugInfo.quantity.$error }"
          >
            <div class="form-label">
              <label>Qty:</label>
            </div>
            <div class="form-quantity">
              <!-- <input type="number" v-model="editDrugInfo.quantity"> -->
              <base-input-whole-number
                class="bax-input-control"
                v-model="editDrugInfo.quantity"
              ></base-input-whole-number>
              <p
                class="error"
                v-if="$v.editDrugInfo.quantity.$dirty && !$v.editDrugInfo.quantity.required"
              >
                Enter a valid quantity
              </p>
              <p
                class="error"
                v-if="$v.editDrugInfo.quantity.$dirty && !$v.editDrugInfo.quantity.min"
              >
                Quantity ordered is less than the minimum of
                {{ this.editDrugInfo.min_order_quantity }}
              </p>
              <p
                class="error"
                v-if="$v.editDrugInfo.quantity.$dirty && !$v.editDrugInfo.quantity.qtyMultiple"
              >
                Order quantity must be in multiples of {{ editDrugInfo.qtyMultiple }}
              </p>
              <p
                class="error"
                v-if="$v.editDrugInfo.quantity.$dirty && !$v.editDrugInfo.quantity.qtyBatchsize"
              >
                New order quantity can't be greater than batch size of
                {{ editDrugInfo.max_batch_size }}
              </p>
            </div>
          </div>
          <div
            v-if="isDateEditable"
            class="bax-form-group"
            v-bind:class="{ 'bax-form-error': $v.editDrugInfo.date.$error }"
          >
            <div class="form-label">
              <label>Treatment date:</label>
            </div>
            <div>
              <date-entry v-model="editDrugInfo.date" :showDateAlerts="true"  @update-warning="updateWarning1"></date-entry>
              <p v-if="$v.editDrugInfo.date.$dirty && !$v.editDrugInfo.date.validDate">
                Enter a valid date
              </p>
              <p v-if="$v.editDrugInfo.date.$dirty && !$v.editDrugInfo.date.pastDate">
                Please enter a future date
              </p>
              <p v-if="$v.editDrugInfo.date.$dirty && !$v.editDrugInfo.date.pastDeliveryDate">
                Please enter date that is after your Date Required
              </p>
              <alert-box :title="'Note'" :date_warning="date_warning1"></alert-box>
            </div>
          </div>
          <div
            v-if="isDateEditable && false"
            class="bax-form-group"
            v-bind:class="{ 'bax-form-error': $v.editDrugInfo.customerDateRequired.$error }"
          >
            <div class="form-label">
              <label>Date required:</label>
            </div>
            <div>
              <date-entry v-model="editDrugInfo.customerDateRequired" :showDateAlerts="true"  @update-warning="updateWarning2"></date-entry>
              <p
                v-if="
                  $v.editDrugInfo.customerDateRequired.$dirty &&
                  !$v.editDrugInfo.customerDateRequired.validDate
                "
              >
                Enter a valid date
              </p>
              <p
                v-if="
                  $v.editDrugInfo.customerDateRequired.$dirty &&
                  !$v.editDrugInfo.customerDateRequired.pastDate
                "
              >
                Please enter a future date
              </p>
              <alert-box :title="'Note'" :date_warning="date_warning2"></alert-box>
            </div>
          </div>
        </div>
        <div class="edit-action-btns">
          <button
            class="bax-btn bax-btn-bordered bax-btn-bordered-blue back-btn"
            type="button"
            @click="isEditModalOpen = false"
          >
            Go back
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button class="bax-btn bax-btn-blue" type="submit" :disabled="allowDrugUpdate">
            Update
          </button>
        </div>
      </form>
      <div v-if="hasError && !updateSuccess">
        <div
          class="bax-icon bax-success d-flex align-items-center justify-content-center error-i-con"
        >
          <i class="icon-exclamation"></i>
        </div>
        <p>{{ errorMessage }}</p>
        <div class="edit-action-btns">
          <button class="bax-btn bax-btn-blue" @click="isEditModalOpen = false" type="button">
            Close
          </button>
        </div>
      </div>
      <div
        class="bax-modal-content bax-modal-icon-content text-center"
        v-if="updateSuccess && !hasError"
      >
        <div class="bax-icon bax-success d-flex align-items-centecr justify-content-center">
          <i class="icon-tick"></i>
        </div>
        <h2>Order item updated</h2>
        <p>We've received your updated order item details!</p>
        <div class="bax-modal-action-items">
          <ul class="d-md-flex justify-content-center">
            <li>
              <a
                href="#"
                @click.prevent="isEditModalOpen = false"
                class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1"
                >Return to orders</a
              >
            </li>
          </ul>
        </div>
      </div>
    </vue-modal>

    <vue-modal :open="isCancelModalOpen">
      <div class="bax-modal-content bax-modal-icon-content text-center" v-if="!cancelSuccess">
        <div class="bax-icon d-flex align-items-center justify-content-center">
          <i class="icon-cancel"></i>
        </div>
        <h2>Cancel your order?</h2>
        <p>Your order will be cancelled and our team will be notified.</p>
        <div class="bax-modal-action-items">
          <ul class="d-md-flex justify-content-center">
            <li>
              <button
                type="button"
                @click="isCancelModalOpen = false"
                class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1"
              >
                Go back
              </button>
            </li>
            <li>
              <button
                type="button"
                @click="onCancelDrug"
                class="bax-btn bax-btn-orange-1 mt-3 mt-md-0"
              >
                Cancel order
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="bax-modal-content bax-modal-icon-content text-center" v-if="cancelSuccess">
        <div class="bax-icon bax-success d-flex align-items-center justify-content-center">
          <i class="icon-tick"></i>
        </div>
        <h2>Order Cancelled</h2>
        <p>Your order has been successfully cancelled!</p>
        <div class="bax-modal-action-items">
          <ul class="d-md-flex justify-content-center">
            <li>
              <button
                type="button"
                @click="isCancelModalOpen = false"
                class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1"
              >
                Return to orders
              </button>
            </li>
          </ul>
        </div>
      </div>
    </vue-modal>
  </app-layout>
</template>

<script>
/* eslint-disable */
import _ from "lodash";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import OrderService from "@/core/api/order/order.service";
import AppLayout from "@/components/layout/AppLayout.vue";
import DateEntry from "@/components/ui/DateEntry.vue";
import PatientList from "./PatientList.vue";
import BaseInputWholeNumber from "@/components/ui/BaseInputWholeNumber.vue";
import BaxHeaderBanner from "@/components/layout/BaxHeaderBanner.vue";
import DownloadOrder from "@/components/order/DownloadOrder.vue";
import tpnMixin from "@/mixins/tpnMixin";
import AlertBox from "@/components/ui/Alert/AlertBox.vue";

export default {
  name: "ManageSingleOrder",
  mixins: [tpnMixin],
  components: {
    AlertBox,
    AppLayout,
    PatientList,
    DateEntry,
    BaseInputWholeNumber,
    BaxHeaderBanner,
    DownloadOrder,
  },
  data() {
    return {
      sortMethod: "alphabetically",
      hospitalName: "",
      hospitalCountry: "",
      isEditModalOpen: false,
      isCancelModalOpen: false,

      orderId: "",
      orderDetail: false,

      orderInfo: {
        orderRef: "",
        orderSource: "",
        date: "",
        time: "",
        patients_count: false,
        items_count: 0,
        patients: {},
        items: {},
      },

      patients: [],
      editDrugInfo: {
        quantity: "",
        date: "",
        customerDateRequired: "",
      },
      selectedDrugEdit: {},
      cancelDrug: {},
      hasError: false,
      errorMessage: "",
      isDateEditable: true,
      cancelSuccess: false,
      updateSuccess: false,
      allChildrenOpen: false,
      allChildrenClosed: false,
      ajaxCalls: 0,
      date_warning1: '',
      date_warning2: '',
    };
  },
  validations: {
    editDrugInfo: {
      quantity: {
        required,
        min(val) {
          if (parseInt(val, 0) < parseInt(this.editDrugInfo.min_order_quantity, 0)) {
            return false;
          }

          return true;
        },
        qtyMultiple(val) {
          if (this.editDrugInfo.qtyMultiple) {
            if (parseInt(val, 0) % this.editDrugInfo.qtyMultiple !== 0) {
              return false;
            }
          }
          return true;
        },
        qtyBatchsize(val) {
          if (
            this.editDrugInfo.max_batch_size &&
            parseInt(this.editDrugInfo.max_batch_size, 0) > 0
          ) {
            if (parseInt(val, 0) > this.editDrugInfo.max_batch_size) {
              return false;
            }
          }
          return true;
        },
      },
      date: {
        validDate(val) {
          if (val === "") {
            return true;
          }

          return moment(val, ["DD/MM/YYYY", "D/M/YYYY"], true).isValid();
        },
        pastDate(val) {
          if (val === "") {
            return true;
          }

          if (moment(val, ["DD/MM/YYYY", "D/M/YYYY"], true).isValid() === false) {
            return true;
          }

          const today = moment().format("DD/MM/YYYY");

          const now = moment(today, "DD/MM/YYYY");
          const date = moment(val, "DD/MM/YYYY");

          if (date.diff(now, "days") < 0) {
            return false;
          }

          return true;
        },
        pastDeliveryDate(val) {
          if (val === "") {
            return true;
          }

          if (moment(val, ["DD/MM/YYYY", "D/M/YYYY"], true).isValid() === false) {
            return true;
          }

          const orderDate = moment(this.orderInfo.date, ["DD/MM/YYYY", "D/M/YYYY"]);

          const now = moment(orderDate, "DD/MM/YYYY");
          const date = moment(val, "DD/MM/YYYY");

          if (date.diff(now, "days") < 0) {
            return false;
          }

          return true;
        },
      },
      customerDateRequired: {
        validDate(val) {
          if (val === "") {
            return true;
          }

          return moment(val, ["DD/MM/YYYY", "D/M/YYYY"], true).isValid();
        },
        pastDate(val) {
          if (val === "") {
            return true;
          }

          if (moment(val, ["DD/MM/YYYY", "D/M/YYYY"], true).isValid() === false) {
            return true;
          }

          const today = moment().format("DD/MM/YYYY");

          const now = moment(today, "DD/MM/YYYY");
          const date = moment(val, "DD/MM/YYYY");

          if (date.diff(now, "days") < 0) {
            return false;
          }

          return true;
        },
      },
    },
  },
  computed: {

    allowDrugUpdate() {
      if (
        this.selectedDrugEdit.quantity !== this.editDrugInfo.quantity ||
        this.selectedDrugEdit.dateRequiredFormatted !== this.editDrugInfo.date
      ) {
        return false;
      }

      return true;
    },
  },
  created() {
    this.hospitalName = this.$store.state.auth.user.hospitalName;
    this.getOrderInfo();
  },
  methods: {
    updateWarning1(newWarning) {
      this.date_warning1 = newWarning
    },
    updateWarning2(newWarning) {
      this.date_warning2 = newWarning
    },
    sortPatients() {
      if (this.sortMethod === "alphabetically") {
        this.patients.sort((a, b) => {
          if (a.key) {
            if (a.key.toLowerCase() < b?.key?.toLowerCase()) return -1;
            if (a.key.toLowerCase() > b?.key?.toLowerCase()) return 1;
          }
          return 0;
        });
      } else if (this.sortMethod === "entry") {
        // If we sort by the merlin order id, it will be in the order entered.
        this.patients.sort((a, b) => {
            if (a.items[0].merlinOrderID < b.items[0].merlinOrderID) return -1;
            if (a.items[0].merlinOrderID > b.items[0].merlinOrderID) return 1;
          return 0;
        });
      }
    },
    onSetCountry(country) {
      this.hospitalCountry = country;
    },
    accordionOpened() {
      this.allChildrenClosed = false;
    },
    accordionClosed() {
      this.allChildrenOpen = false;
    },
    openAllDetails() {
      this.allChildrenOpen = true;
      this.allChildrenClosed = false;
      this.patients.forEach((value, index) => {
        let childName = "patient" + index;
        this.$refs[childName][0].openAll();
      });
    },
    closeAllDetails() {
      this.allChildrenOpen = false;
      this.allChildrenClosed = true;

      this.patients.forEach((value, index) => {
        let childName = "patient" + index;
        this.$refs[childName][0].closeAll();
      });
    },
    getOrderInfo() {
      this.orderInfo.orderRef = "";
      this.orderInfo.orderSource = "";
      this.orderInfo.date = "";
      this.orderInfo.customerDateRequired = "";
      this.orderInfo.time = "";
      this.orderInfo.patients_count = false;
      this.orderInfo.items_count = 0;
      this.orderInfo.patients = {};

      if (this.isTPN()) {
        this.ajaxCalls++;
        OrderService.getTpnOrderDetail(this.$route.params.orderId).then((res) => {
          this.ajaxCalls--;
          const { data } = res;
          if (data.date_required === 'Multiple Dates') {
            var tpn_date_req = data.date_required;
          } else {
            var tpndate = data.patients_data['Others']['items']['0'].customerRequiredDate;
            var tpn_date_req = moment(tpndate).format('DD/MM/YYYY');
          }
          this.orderId = data.orderReference;
          this.orderInfo.orderRef = data.orderReference;
          this.orderInfo.date = tpn_date_req;
          this.orderInfo.time = data.time_required;
          this.orderInfo.items_count = data.items_ordered_count;
          this.orderInfo.comment = data.comment;
          this.patients = [];

          const _this = this;
          Object.keys(data.patients_data)
            .sort()
            .forEach(function (key) {
              data.patients_data[key]['key'] = key;
              _this.patients.push(data.patients_data[key]);
            });

          this.orderDetail = data;
        });
      } else {
        //
        // OrderService.getOrderDetail(this.$route.params.orderId)
        //   .then((res) => {
        //     const { data } = res;
        //     this.orderId = data.orderReference;
        //     this.orderInfo.orderRef = data.orderReference;
        //     this.orderInfo.date = data.date_required;
        //     this.orderInfo.time = data.time_required;
        //     this.orderInfo.patients_count = data.patients_count;
        //     this.orderInfo.items_count = data.items_ordered_count;
        //     this.orderInfo.comment = data.comment;
        //
        //
        //     this.patients = [];
        //     const _this = this;
        //     Object.keys(data.patients_data).sort().forEach(function(key) {
        //       _this.patients.push(data.patients_data[key])
        //     })
        //
        //     this.orderDetail = data;
        //   });
        const data = {};
        data.groupOrderId = this.$route.params.orderId;
        data.step = "orderlines";
        data.ident = this.$route.params.orderId;
        data.async = true;
        data.type = this.isTPN() ? "TPN" : "CMP";
        this.ajaxCalls++;
        OrderService.getOrderDetailAsync(data).then((res) => {
          this.ajaxCalls--;
          const { data } = res;
          if (!data.load_async) {
            const { data } = res;
            this.orderId = data.orderReference;
            this.orderInfo.orderRef = data.orderReference;
            this.orderInfo.date = data.date_required;
            this.orderInfo.time = data.time_required;
            this.orderInfo.patients_count = data.patients_count;
            this.orderInfo.items_count = data.items_ordered_count;
            this.orderInfo.comment = data.comment;

            this.patients = [];
            const _this = this;
            Object.keys(data.patients_data)
              .sort()
              .forEach(function (key) {
                data.patients_data[key]['key'] = key;
                _this.patients.push(data.patients_data[key]);
              });

            this.orderDetail = data;
          } else {
            this.orderId = data.orderReference;
            this.orderInfo.orderRef = data.orderReference;
            const v = this;
            Object.keys(data.orderlines).forEach(function (i) {
              const orderlinedata = {};

              orderlinedata.order_reference = data.orderlines[i].purchaseOrderNo;
              orderlinedata.orderSource = data.orderlines[i].orderSource;
              v.orderSource = data.orderlines[i].orderSource;
              orderlinedata.order_id = data.orderlines[i].merlinOrderID;
              orderlinedata.order_type = data.orderlines[i].orderType;
              v.loadOrderDetails(orderlinedata);
            });
          }
        });
      }
    },
    loadOrderDetails(data) {
      data.groupOrderId = this.$route.params.orderId;
      data.orderSource = this.orderSource;
      data.step = "orderdetails";
      data.async = true;
      data.type = this.isTPN() ? "TPN" : "CMP";
      const v = this;
      this.ajaxCalls++;
      OrderService.getOrderDetailAsync(data).then((res) => {
        this.ajaxCalls--;
        const { data } = res;

        Object.keys(data.orderdetails.patients_data).forEach(function (p) {
          const unordered = v.orderInfo.patients;
          if (p in v.orderInfo.patients) {
            v.orderInfo.patients[p].items = unordered[p].items.concat(
              data.orderdetails.patients_data[p].items
            );
            v.orderInfo.patients[p].key = p;
          } else {
            v.orderInfo.patients[p] = data.orderdetails.patients_data[p];
            v.orderInfo.patients[p].key = p;
          }

          v.orderInfo.order_reference = data.orderdetails.order_reference;
          v.orderInfo.patients_count =
            v.orderInfo.patients_count + data.orderdetails.patients_count;
          v.orderInfo.items_count = v.orderInfo.items_count + data.orderdetails.items_ordered_count;
          if (v.orderInfo.date && (v.orderInfo.date != data.orderdetails.date_required)) {
            v.orderInfo.date = 'Multiple Dates'
          } else {
            v.orderInfo.date = data.orderdetails.date_required;
          }
          // v.orderInfo.date = data.orderdetails.date_required;
          v.orderInfo.time = data.orderdetails.time_required;
          if (!v.orderInfo.comment) {
            v.orderInfo.comment = data.orderdetails.comment;
          }
        });

        this.patients = [];
        const _this = this;
        const keys = Object.keys(this.orderInfo.patients).sort();
        keys.forEach(function (k) {
          const copy = JSON.parse(JSON.stringify(_this.orderInfo.patients[k]));
          _this.patients.push(copy);
        });

        this.orderInfo.patients_count = Object.keys(this.patients).length;

        this.orderDetail = this.orderInfo;
        this.orderDetail.orderReference = this.orderInfo.orderRef;
        this.orderDetail.date_required = this.orderInfo.date;
        this.orderDetail.patients_count = this.orderInfo.patients_count;
        this.orderDetail.items_ordered_count = this.orderInfo.items_count;
        this.orderDetail.orderReference = this.orderInfo.orderRef;

      });
    },

    // open edit drug modal
    onEditDrug(drug, patient) {
      if (patient && patient.details) {
        if (typeof patient.details.patientID !== "undefined" && patient.details.patientID !== "") {
          this.isDateEditable = true;
        } else {
          this.isDateEditable = false;
        }
      } else {
        this.isDateEditable = false;
      }

      if (this.isTPN()) {
        this.isDateEditable = false;
      }
      this.hasError = false;
      this.updateSuccess = false;
      this.errorMessage = "";

      let drugName = drug.drug1Name;
      if (drug.drug2Name) {
        drugName = drugName + " & " + drug.drug2Name;
      }

      this.editDrugInfo = {
        merlinOrderID: drug.merlinOrderID,
        merlinOrderLineID: drug.merlinOrderLineID ? drug.merlinOrderLineID : drug.orderLineId,
        drugName: drugName,
        orderId: this.orderId,
        quantity: drug.quantity,
        date: drug.administrationDateFormatted || "",
        customerDateRequired: drug.dateRequiredFormatted,
        order_line_type: drug.order_line_type,
        max_batch_size: drug.max_batch_size,
        min_order_quantity: drug.min_order_quantity,
        qtyMultiple: parseInt(drug.multiple, 0),
      };

      this.selectedDrugEdit = drug;
      this.isEditModalOpen = true;
    },
    goBack() {
      const { from, order, search } = this.$route.query;
      if (typeof from === "undefined") {
        if (this.isTPN()) {
          this.$router.push({
            name: "homeTPN",
          });
        } else {
          this.$router.push({
            name: "home",
          });
        }
      }

      if (from === "manageOrders") {
        let queryString = {};
        if (order && order !== "") {
          queryString.order = order;
        }
        if (search && search !== "") {
          queryString.q = search;
        }

        this.$router.push({
          name: from,
          query: queryString,
        });
      } else if (from === "manageTpnOrders") {
        let queryString = {};
        if (order && order !== "") {
          queryString.order = order;
        }
        if (search && search !== "") {
          queryString.q = search;
        }

        this.$router.push({
          name: from,
          query: queryString,
        });
      } else {
        if (this.isTPN()) {
          this.$router.push({
            name: "homeTPN",
          });
        } else {
          this.$router.push({
            name: "home",
          });
        }
      }
    },
    updateOrderData() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      let drugName = this.editDrugInfo.drugName;
      if (this.editDrugInfo.drug2Name) {
        drugName = drugName + " & " + this.editDrugInfo.drug2Name;
      }

      const data = {
        merlinOrderID: this.editDrugInfo.merlinOrderID,
        merlinOrderLineID: this.editDrugInfo.merlinOrderLineID,
        customerRequiredDate: this.editDrugInfo.customerDateRequired,
        orderId: this.orderId,
        type: this.editDrugInfo.order_line_type,
        drugName: drugName,
      };

      if (this.selectedDrugEdit.quantity !== this.editDrugInfo.quantity) {
        data.quantity = this.editDrugInfo.quantity;
      }

      if (this.selectedDrugEdit.dateRequiredFormatted !== this.editDrugInfo.date) {
        data.treatmentDate = this.editDrugInfo.date;
      }

      OrderService.updateOrder(data)
        .then(() => {
          this.hasError = false;
          this.updateSuccess = true;
          this.getOrderInfo();
        })
        .catch((err) => {
          this.updateSuccess = false;
          this.hasError = true;
          this.errorMessage = err.response.data.message;
          this.$Progress.fail();
        })
        .then(() => {});
    },
    showCancelDrugModal(drug) {
      this.cancelSuccess = false;
      this.isCancelModalOpen = true;
      this.cancelDrug = drug;
    },

    onOrderChanged() {
      this.getOrderInfo();
    },

    onCancelDrug() {
      let drugName = this.cancelDrug.drug1Name;
      if (this.cancelDrug.drug2Name) {
        drugName = drugName + " & " + this.cancelDrug.drug2Name;
      }
      OrderService.cancelOrder({
        merlinOrderID: this.cancelDrug.merlinOrderID,
        merlinOrderLineID: this.cancelDrug.merlinOrderLineID
          ? this.cancelDrug.merlinOrderLineID
          : this.cancelDrug.orderLineId,
        orderLineId: this.cancelDrug.orderLineId,
        orderId: this.orderId,
        drugName: drugName,
        type: this.cancelDrug.order_line_type,
      })
        .then(() => {
          this.cancelSuccess = true;
          this.getOrderInfo();
        })
        .catch(() => {})
        .then(() => {
          this.$Progress.finish();
        });
    },
  },
};
</script>

<style scoped lang="scss">
.bax-form-group {
  display: flex;
  margin-bottom: 22px;

  .form-label {
    width: 48%;
    text-align: right;
    padding-right: 15px;
    font-weight: 500;

    label {
      font-size: 18px;
      margin-top: 18px;
    }
  }

  .form-quantity {
    input {
      width: 120px;
    }
  }
}

.edit-i-con {
  background-color: #003399 !important;
}

.error-i-con {
  background-color: #eb5a46 !important;
}

.edit-title {
  display: block;
  margin-bottom: 40px;
  font-size: 28px;
  font-weight: 500;
}

.edit-action-btns {
  button {
    // margin-right: 20px;
  }

  .back-btn {
    border: 1px solid #4e4e4e;
    color: #4e4e4e;
    padding-left: 40px;
    padding-right: 40px;
  }
}

.bax-form-error {
  input {
    border: 1px solid red;
  }

  p {
    text-align: left;
    margin-bottom: 0;
  }

  .form-quantity {
    text-align: left;
  }
}
</style>
